import { useContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BottomNav from "../../components/BottomNav";
import styles from "./menuconteudo.module.css";
import BackIcon from "../../components/BackIcon";
import { AuthContext } from "../../context/AuthContext";
import { lc, resolveUrl } from "../../context/MenuContext";
import { getMenuItemHotspots, getMenuItemDetalhe, getImagemMenuItemUrl } from "../../services/api";

// Tela genérica pra item de menu tipo 'conteudo' (ver MenuContext.jsx/
// SectionSheet.jsx) - Endomarketing cria só imagem e/ou texto num item de
// menu, sem precisar programar uma tela nova toda vez. Recebe o conteúdo já
// carregado junto com o menu (via state da navegação), sem chamada de API
// própria pro conteúdo em si - modelo simplificado da tela de Comunicado
// (sem reações/comentários).
//
// Hotspots (pedido do usuário, 2026-09-02): se a imagem tiver botões
// desenhados nela, o Endomarketing pode marcar áreas clicáveis por cima
// (ver HotspotEditor no CozimaxERP) - aqui busca essas áreas por API (não
// vêm no state, só existem depois que o item já foi criado) e desenha
// divs invisíveis nas posições marcadas (% da imagem, não pixel).
export default function MenuConteudo() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const { user } = useContext(AuthContext);

    const item = state?.item;
    const titulo = state?.titulo;
    const icone = state?.icone;
    const subtitulo = item?.subtitulo;
    const viaHotspot = !!state?.viaHotspot;

    const [hotspots, setHotspots] = useState([]);

    useEffect(() => {
        if (!item?.codite) { setHotspots([]); return; }
        getMenuItemHotspots(item.codite)
            .then(lista => setHotspots(lista.map(lc)))
            .catch(() => setHotspots([]));
    }, [item?.codite]);

    if (!item) { navigate("/home", { replace: true }); return null; }

    async function aoClicarHotspot(h) {
        if (h.tipodestino === "rota") {
            navigate(h.destino);
        } else if (h.tipodestino === "url") {
            window.open(resolveUrl(h.destino, user), "_blank");
        } else if (h.tipodestino === "conteudo") {
            // destino é o codite (texto) do outro item de conteúdo - busca os
            // dados dele na hora (não vêm pré-carregados, ao contrário do
            // primeiro item, que chega via state a partir do menu principal).
            const alvo = await getMenuItemDetalhe(h.destino);
            if (!alvo) return;
            const a = lc(alvo);
            // Só substitui (replace) a partir do 2º salto em diante - o 1º
            // continua empilhando (push), senão perde a página original da
            // sequência do histórico (achado do usuário, 2026-09-02: com
            // replace sempre, "voltar" pulava a página original inteira e
            // saía do menu direto). Com isso, "voltar" de qualquer ponto da
            // cadeia sempre cai exatamente na página original, em 1 clique -
            // nunca menos (perderia a original) nunca mais (empilharia 1
            // entrada por imagem visitada).
            navigate("/menu-conteudo", {
                replace: !!state?.viaHotspot,
                state: {
                    item: {
                        codite: a.codite,
                        texto: a.conteudotexto,
                        imagemUrl: a.conteudoimagem ? getImagemMenuItemUrl(a.codite) : null,
                        subtitulo: a.subtitulo,
                    },
                    titulo: a.label,
                    icone: a.icone,
                    viaHotspot: true,
                },
            });
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                {viaHotspot && (
                    <button className={styles.btnVoltar} onClick={() => navigate(-1)}><BackIcon /></button>
                )}
                {icone && <span className={styles.headerIcone}>{icone}</span>}
                <div className={styles.headerTexto}>
                    <h2>{titulo}</h2>
                    {subtitulo && <p className={styles.headerSubtitulo}>{subtitulo}</p>}
                </div>
            </div>

            <div className={styles.card}>
                {item.imagemUrl && (
                    <div className={styles.imagemWrap}>
                        <img src={item.imagemUrl} className={styles.imagem} alt={titulo} />
                        {hotspots.map(h => (
                            <div
                                key={h.id}
                                className={styles.hotspot}
                                style={{ left: `${h.posx}%`, top: `${h.posy}%`, width: `${h.largura}%`, height: `${h.altura}%` }}
                                onClick={() => aoClicarHotspot(h)}
                            />
                        ))}
                    </div>
                )}
                {item.texto && (
                    <div
                        className={styles.textoCompleto}
                        dangerouslySetInnerHTML={{ __html: item.texto }}
                    />
                )}
            </div>

            <BottomNav />
        </div>
    );
}
